import { Answer } from "../Model/Answer";
import { Query } from "../Model/Query";
export class AnswersService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    getInstanceAnsers(instanceId) {
        const query = new Query(0, 1000);
        query.addFilter('id_instance', [instanceId]);
        return this.queryAnswers(query, instanceId);
    }
    async queryAnswers(query, instanceId) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        if (hasNetwork) {
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`answers?${params}`);
            if (!response.ok) {
                throw new Error('Ha ocurrido un error al obtener las respuestas.');
            }
            const content = await response.json();
            const datasString = JSON.stringify(content);
            localStorage.setItem(`answer-${instanceId}`, datasString);
            return content.map(data => this.createAnswer(data));
        }
        const answers = JSON.parse(localStorage.getItem(`answer-${instanceId}`));
        if (!answers || answers.length === 0) {
            throw new Error('Ha ocurrido un error al obtener las respuestas CACHE.');
        }
        return answers.map(data => this.createAnswer(data));
    }
    async saveAnswer(answer) {
        const localAnswers = localStorage.getItem(`answer-${answer.instanceId}`);
        if (localAnswers) {
            const localAnswersParse = JSON.parse(localAnswers);
            const localAnswer = localAnswersParse.find(a => a.id == answer.id);
            if (localAnswer) {
                localAnswer.value = answer.value;
            }
            else {
                localAnswersParse.push(answer);
            }
            localStorage.setItem(`answer-${answer.instanceId}`, JSON.stringify(localAnswersParse));
        }
        const response = await this.apiService.post('answer', answer);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al guardar la respuesta.');
        }
    }
    createAnswer(data) {
        return new Answer(data.id, data.instanceId, data.questionId, data.value);
    }
}
